import React from 'react';
import Reflux from 'reflux';
import UIRegions from 'shared/constants/UIRegions';
import Modal from 'shared/components/misc/modal.jsx';
import UpgradeAlert from 'shared/components/misc/upgradeAlert';
import UpgradeAlertModalStore from 'flux/stores/UpgradeAlertModalStore';
import { Row } from 'bootstrap';

/**
 * Upgrade Alert Modal
 *
 */
export default React.createClass({
  displayName: 'UpgradeAlertModal',

  mixins: [Reflux.connect(UpgradeAlertModalStore, 'store')],

  render() {
    let { store } = this.state;

    return (
      <Modal
        className="modal-generic-wrapper upgrade-alert-modal"
        headerClassName="modal-generic-header"
        name={UIRegions.UpgradeAlert}
      >
        <Row>
          <UpgradeAlert
            display={true}
            type={store.get('type')}
            classes={store.get('classes')}
            title={store.get('title')}
            desc={store.get('desc')}
            assetLink={store.get('assetLink')}
            learnMoreLink={store.get('learnMoreLink')}
            upgradeLink={store.get('upgradeLink')}
          />
        </Row>
      </Modal>
    );
  },
});
